var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClear(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Clear",
    transform: "translate(-1508 -213)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    width: 18,
    height: 18,
    transform: "translate(1508 213)",
    fill: "#d72525",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Clear-2",
    "data-name": "Clear",
    d: "M19.5,8.709,18.291,7.5,13.5,12.291,8.709,7.5,7.5,8.709,12.291,13.5,7.5,18.291,8.709,19.5,13.5,14.709,18.291,19.5,19.5,18.291,14.709,13.5Z",
    transform: "translate(1503.5 208.5)",
    fill: "#d72525"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClear);
export default __webpack_public_path__ + "static/media/clear.98070e963b073e0110034c345d32f913.svg";
export { ForwardRef as ReactComponent };